import * as Adaptive from 'adaptivecards';
import { isFeatureEnabled } from 'owa-feature-flags';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

export default function registerHostCapabilities(hostCapabilities: Adaptive.HostCapabilityMap) {
    if (isFeatureEnabled('rp-actionableMessages-aad-token') && !isConsumer()) {
        hostCapabilities['AADAuthentication'] = '*';
    }
}
